import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { useBreadcrumbs, useSeoMeta } from 'hooks';
import { getLocaleUrlPath } from 'utils';

import BreadCrumbs from 'components/BreadCrumbs';

export const HomePageBreadCrumbs = () => {
  const location = useLocation();
  const { pageTitle } = useSeoMeta();
  const { locale, formatMessage } = useIntl();

  const localeInURL = getLocaleUrlPath(locale);
  const routerBasename = `${localeInURL}${process.env.APP_ROUTER_BASENAME}`;

  const breadcrumbsPlaceholders = [
    {
      name: formatMessage({ id: 'breadcrumbs.mainPage' }),
      link: getLocaleUrlPath(locale),
    },
    {
      name: pageTitle,
      link: `${routerBasename}${location.pathname}`,
    },
  ];

  const breadcrumbs = useBreadcrumbs(breadcrumbsPlaceholders);

  return breadcrumbs.length ? <BreadCrumbs breadcrumbs={breadcrumbs} /> : null;
};

export default memo(HomePageBreadCrumbs);
